module.exports = "<div class=\"row mb-md top-row-ports\"></div>\n<div class=\"row bottom-row-ports\"></div>\n";
